import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './corporate/HeroSection';
import { IntroSection } from './corporate/IntroSection';
import { SecurityAndInvestigationsSection } from './corporate/SecurityAndInvestigationsSection';
import { CapabilitiesSection } from './corporate/CapabilitiesSection';
import { SurveillanceServicesSection } from './corporate/SurveillanceServicesSection';
import { IndividualServicesSection } from './corporate/IndividualServicesSection';
export function CorporatePage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-474">
      <Navbar data-id="element-475" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-476">
        <HeroSection data-id="element-477" />
        <IntroSection data-id="element-478" />
        <SecurityAndInvestigationsSection data-id="element-479" />
        <CapabilitiesSection data-id="element-480" />
        <SurveillanceServicesSection data-id="element-481" />
        <IndividualServicesSection data-id="element-482" />
      </main>
      <Footer data-id="element-483" />
    </div>;
}